import { Box, Typography } from '@mui/material';
import { SECTOR_COLORS, ROW_H } from './constants';

const RouteRowLabel = ({ rowKey, flights, groupBy, theme }) => {
  const sectorType = flights[0]?.sectorType;
  const sc         = SECTOR_COLORS[sectorType] || SECTOR_COLORS.def;
  const acTypes    = [...new Set(flights.map((f) => f.acType).filter(Boolean))];
  const freq       = flights.reduce((s, f) => s + (f.frequency || 1), 0);
  // const totalBlk   = flights.reduce((s, f) => s + (f.blockTime || 0), 0);
  // const blkTxt     = totalBlk > 0 ? `${Math.floor(totalBlk / 60)}h${String(totalBlk % 60).padStart(2, '0')}m` : '';

  return (
    <Box 
      sx={{
        height: ROW_H, 
        px: 1, 
        py: 0.5,
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`,
        bgcolor: sc.bg,
        gap: 0.25,
      }}
    >
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography 
          sx={{ 
            fontSize: '0.75rem', 
            fontFamily: 'monospace', 
            lineHeight: 1,
            fontWeight: 'bold', 
            color: sc.label, 
          }}
        >
          {rowKey}
        </Typography>
        {groupBy === 'route' && sectorType && (
          <Box 
            sx={{ 
              fontSize: '0.5rem', 
              bgcolor: 'rgba(255,255,255,0.25)', 
              color: 'text.primary', 
              borderRadius: '2px', 
              px: 0.4, 
              lineHeight: 1.6, 
              fontFamily: 'monospace',
            }}
          >
            {sectorType}
          </Box>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography sx={{ fontSize: '0.6rem', color: sc.sub, fontFamily: 'monospace' }}>
          {flights.length} · {freq}x/w
        </Typography>
      </Box>
      <Box 
        display="flex" 
        flexWrap="wrap"
        gap={0.25} 
      >
        {acTypes.map((t) => (
          <Box 
            key={t} 
            sx={{ 
              fontFamily: 'monospace', 
              fontSize: '0.6rem', 
              lineHeight: 1.5, 
              bgcolor: 'success.main', 
              color: 'text.primary', 
              borderRadius: 1, 
              px: 0.25, 
            }}
          >
            {t}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RouteRowLabel;
